import { Button } from '@/components/elements/forms/buttons';
import { trackMpEvent } from '@/helpers/analyticsTS';
import useMobileView from '@/hooks/useMobileView';
import { _s } from '@/locale';
import { useEffect } from 'react';
import Modal from './redesign/Modal/Modal';

const LogoutModal = ({ isOpen, onClick, onClose }: { isOpen: boolean; onClick: () => void; onClose: () => void }) => {
  const { isMobileView } = useMobileView();
  const translationKey = `account-settings.logout-modal`;

  useEffect(() => {
    if (!isOpen) return;
    trackMpEvent({
      name: 'logout_flow',
      properties: { logout_step: 'initiated' },
    });
  }, [isOpen]);

  function handleOnClose() {
    trackMpEvent({
      name: 'logout_flow',
      properties: { logout_step: 'cancelled' },
    });
    onClose();
  }

  function handleOnClick() {
    trackMpEvent({
      name: 'logout_flow',
      properties: { logout_step: 'successful' },
    });
    onClick();
  }

  return (
    <Modal isOpen={isOpen}>
      <Modal.Content floating>
        <Modal.Header title={_s(`${translationKey}.title`)} />
        <div className={`gap-sm flex flex-col ${isMobileView ? 'px-lg' : ''}`}>
          <p className="text-black-600">{_s(`${translationKey}.body`)}</p>
        </div>
        <Modal.Footer>
          <Button variant="link" size="sm" onClick={handleOnClick}>
            {_s(`${translationKey}.logout-button`)}
          </Button>
          <Button variant="primary" size="sm" onClick={handleOnClose}>
            {_s(`${translationKey}.cancel-button`)}
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
};

export default LogoutModal;
